module.exports = __webpack_public_path__ + "img/OverseaMember38.38b4fbaa.jpg";